export default __webpack_public_path__ + "static/media/default.5317aa5e.png";